import { Button, Checkbox, Modal, Segment } from 'semantic-ui-react';
import Utils from '../../../../../../../../../utils/descriptor/descriptorUtils';
import "./styles.css"

type ModelFieldSelectionPropsType = {
    selectedDescriptorIds: string[];
    descriptorsIdsAvailableForSelection: string[];
    //TODO: Create a type for the descriptor
    descriptors: any;
    onSelect: (descriptorId: string) => void;
};

type ModelFieldSelectionModalPropsType = {
    open: boolean;
    onConfirm: () => void;
} & ModelFieldSelectionPropsType;

function ModelFieldSelectionModal({
    open,
    onConfirm,
    descriptors,
    descriptorsIdsAvailableForSelection,
    onSelect,
    selectedDescriptorIds,
}: ModelFieldSelectionModalPropsType) {
    return (
        <Modal open={open}>
            <Modal.Content>
                <ModelFieldSelection
                    descriptors={descriptors}
                    descriptorsIdsAvailableForSelection={descriptorsIdsAvailableForSelection}
                    selectedDescriptorIds={selectedDescriptorIds}
                    onSelect={onSelect}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button primary onClick={onConfirm}>
                    Save
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

function ModelFieldSelection({
    descriptorsIdsAvailableForSelection,
    descriptors,
    onSelect,
    selectedDescriptorIds,
}: ModelFieldSelectionPropsType) {
    return (
        <>
            {descriptors.map((d: any) => {
                return (
                    <Segment key={d.id} className='model-selection__field-segment'>
                        <Checkbox
                            label={Utils.getDescriptorLabel(d)}
                            disabled={!descriptorsIdsAvailableForSelection.includes(d.id)}
                            checked={selectedDescriptorIds.includes(d.id)}
                            onChange={() => onSelect(d.id)}
                        />
                        <ModelFieldSelection
                            descriptors={d.subFields}
                            descriptorsIdsAvailableForSelection={descriptorsIdsAvailableForSelection}
                            onSelect={onSelect}
                            selectedDescriptorIds={selectedDescriptorIds}
                        />
                    </Segment>
                );
            })}
        </>
    );
}

export default ModelFieldSelectionModal;
